import { createMockCreator } from '@csp/test-common-utils';
import { CountryV1 } from '../generated/models/CountryV1';

export const countryV1Mock: CountryV1 = {
  langCodes: ['sv', 'fi'],
  countryCode: 'se',
};

export const createCountryV1Mock = createMockCreator(countryV1Mock);
